import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../Contexts/AppContext";
const Hero = () => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");

  useEffect(() => {
    setCurrentBG(
      context.isLight
        ? context.currentTheme["commerce"].bg
        : context.currentTheme["commerce"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["commerce"].text
        : context.currentTheme["commerce"].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme["commerce"].dropdown
        : context.currentTheme["commerce"].dark_dropdown
    );
  }, [context]);
  return (
    <div
      style={{
        backgroundImage: `linear-gradient(to bottom, #00003577, #00003577), url('${process.env.REACT_APP_IMAGES_URL}/Assets/Images/E-Commerces/ESPER/hero-img.jpg')`,
        backgroundColor: currentBG,
        color: context.isLight ? currentColor : currentText,
      }}
      className="flex h-[calc(100vh-56px)] flex-col justify-center bg-cover bg-fixed bg-center bg-no-repeat"
    >
      <div className="pl-5">
        <h1 className="mb-3 text-4xl font-semibold tracking-widest ss:text-6xl">
          DELICIOUS HONEY
        </h1>
        <p className="mb-10 text-lg tracking-wider ss:text-2xl">
          Organic honey for healthy life
        </p>
        <a
          href="/"
          target="_blank"
          rel="noreferrer"
          className="my-2 ml-5 rounded border-2 py-1 px-3 text-lg font-semibold uppercase tracking-wider transition-all ss:rounded-xl ss:border-4 ss:py-2 ss:px-5 ss:text-xl ss:font-bold ss:tracking-widest"
          onMouseEnter={(e) => {
            e.target.style.borderColor = currentBG;
            e.target.style.backgroundColor = currentBG;
            e.target.style.color = currentText;
          }}
          onMouseLeave={(e) => {
            e.target.style.borderColor = "unset";
            e.target.style.backgroundColor = "unset";
            e.target.style.color = "unset";
          }}
        >
          Visit Us
        </a>
      </div>
    </div>
  );
};

export default Hero;
